export const DEADLINE = {
  OVERDUE: {
    id: 'overdue',
    name: 'Em Atraso',
    color: 'text-[var(--brand-red)]'
  },
  DUE: { id: 'due', name: 'Vencendo', color: 'text-[var(--brand-orange)]' },
  UP_TO_DATE: {
    id: 'upToDate',
    name: 'Em Dia',
    color: 'text-[var(--brand-green)]'
  }
}
